/**
 * This is not a production server yet!
 * This is only a minimal backend to get started.
 */

import { AppModule } from './app/app.module';
import { NestFactory } from '@nestjs/core';
import { SwaggerModule, DocumentBuilder } from '@nestjs/swagger';
import 'dotenv/config';
import { Logger, ValidationPipe } from '@nestjs/common';
import { HttpExceptionFilter, LoggingInterceptor } from '@gtpl/shared-utils/error-messages';
import { PinoLogger } from 'nestjs-pino';
import { NestJsLogger } from '../../logger/nest-js-logger';
import {appSettings} from '../../config';

async function bootstrap() {
  const app = await NestFactory.create(AppModule);
  app.enableCors();
   
   const globalPrefix = 'erpx';
   app.setGlobalPrefix(globalPrefix);
   const port =  appSettings.finance_port;
   const options = new DocumentBuilder()
     .setTitle('ERPX')
     .setDescription('ERP X')
     .setVersion('1.0')
     .addTag('')
     .build();
   const document = SwaggerModule.createDocument(app, options);
   SwaggerModule.setup('erpx', app, document);
   // await app.listen(3000);
   await app.listen(port, () => {
     Logger.log('Listening at http://localhost:' + port + '/' + globalPrefix);
   });

}

bootstrap();
